export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/imageCompressWebpackWorker.8c4caf65.worker.js");
}
